import { render } from "./academicssettings.vue?vue&type=template&id=47de56b5&scoped=true"
import script from "./academicssettings.vue?vue&type=script&lang=js"
export * from "./academicssettings.vue?vue&type=script&lang=js"

import "@/assets/css/ts-table.css?vue&type=style&index=0&id=47de56b5&scoped=true&lang=css&external"
import "./academicssettings.vue?vue&type=style&index=1&id=47de56b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47de56b5"]])

export default __exports__